import { createRouter, createWebHashHistory } from 'vue-router';

import { routes as digitalCommisions } from '@/app/modules/DigitalCommisions/router/index';
import { routes as eventRoutes } from '@/app/modules/Events/router/index';
import { routes as exportPotential } from '@/app/modules/ExportPotential/router/index';
import { routes as internationalTrade } from '@/app/modules/InternationalTrade/router/index';
import { routes as marketAccessRoutes } from '@/app/modules/MarketsAccess/router/index';
// Роуты функциональных модулей
import { routes as perechenMer } from '@/app/modules/MeasuresTtrStd/router/index';
import { routes as memberNavigator } from '@/app/modules/MemberNavigator/router/index';
import { routes as authRoutes, registerGuards as registerAuthGuards } from '@/app/modules/auth/router/index';
import { routes as lk } from '@/app/modules/lk/router/index';
import { routes as news } from '@/app/modules/news/router/index';

import constants from '@/common/constants';
import { menuActive } from '@/common/mixins/menu-active.js';
import runtimeConfig from '@/common/runtime-config';
import { checkMenuGuard } from '@/common/utils';

const routes = [
  { path: '/', name: 'home', component: () => import('@/app/modules/Home/HomePage.vue') },
  ...authRoutes,
  ...perechenMer,
  ...memberNavigator,
  ...marketAccessRoutes,
  ...internationalTrade,
  ...exportPotential,
  ...lk,
  ...digitalCommisions,
  ...eventRoutes,
  ...news,

  {
    path: constants.PATHS.ANALITCS_COUNTRIES,
    name: 'analitcs-countries',
    //redirect: runtimeConfig.adminRedirectUrl + '/#/Country'
    beforeEnter: [
      checkMenuGuard,
      () => {
        window.location.replace(runtimeConfig.adminRedirectUrl + '/#/Country');
      },
    ],
  },
  {
    path: constants.PATHS.NOT_FOUND,
    name: 'NotFound',
    component: () => import('@/app/shared/components/NotFound.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: constants.PATHS.NOT_FOUND,
  },
];

const router = createRouter({
  mode: 'history',
  history: createWebHashHistory(),
  routes,
});

registerAuthGuards(router);

router.afterEach(async () => {
  await router.isReady();
  menuActive(router.currentRoute._value.href);
});

export default router;
